import { useContext } from 'react';
import JourneyListContext, { IJourneyListContextProps } from './JourneyListContext';

const useJourneyListContext = (): IJourneyListContextProps => {
  return useContext(JourneyListContext);
};

export default useJourneyListContext;
